var ww = $(window).width();
var wh = $(window).height();
var offset = 60;

var mobile = false;
var tablet = false;
var touch = false;


var prevhref = document.location.pathname;

//slideshow vars
var seasing = "easeOutCubic";
var sspeed = 540;
var scounter = 0;
var sreset = false;

var disabletap = true;

var oktohidehead = true;
var oktopagemove = true;

var pdir = "next";

var sitetitle = "Sutram";

var slideup = true;
var slidedown = true;	

var core = {
	
    init: function() {
	    core.siteResize();
	    core.slideshowInit();
        core.siteLoad();
		core.rowHover();
		setTimeout(()=>{document.body.classList.add('show-dots')}, 4000)
    },
    
    siteLoad: function() {
	    	    	    
		FastClick.attach(document.body);
		
		$(window).on({
			resize: function() {
				core.siteResize();
			},
			load: function() {
	            $('body').addClass('loaded');				
			}
		});
				 

		
		//mobile nav events
	    $("body").on("tap", ".viewmoreimgs", function(e) {
		    
			e.preventDefault();
			e.stopPropagation();			
			
			if (disabletap && mobile) {
				$(".btn.next").click();
			}

		});
				
	    $("body").on("swipeleft", ".slideshow", function(e) {	
			if (ww<=1024) {
				core.slideshowClick($(this),"next");
			}
		});
		
	    $("body").on("tap", ".slideshow", function(e) {
			if (!disabletap && mobile) {
				core.slideshowClick($(this),"next");				
			}
		});
		
	    $("body").on("swiperight", ".slideshow", function(e) {
			if (ww<=1024) {
				core.slideshowClick($(this),"prev");				
			}
		});	
		
	    $("body").on("click", ".logo", function(e) {
							
			var menu = $(".menu");
			
			if (!menu.is(":visible") && mobile) {
				e.preventDefault();
				menu.velocity("slideDown",180);
				if ($("body").hasClass("b_journal")) {
					$(this).addClass("black");
				}					
			}
							
		});
		
	    $("body").on("click", ".sbtn", function(e) {
						
			e.preventDefault();
			e.stopPropagation();
			
		    var tel = $(this);
			var sdir = (tel.hasClass('next')) ? "next" : "prev";		    
			
			core.slideshowClick($(".items"),sdir);
						
		});		
				
			$("body").on("click", ".items", function (event) {
				console.log(event)

			event.stopPropagation();		

			var tel = $(this);		
			var telw = tel.width();
			var telpos = tel.offset();			
			var left = event.clientX - telpos.top;
			var sdir = (left > (telw / 2)) ? "next" : "prev";			
			var e = event.toElement || event.relatedTarget || event.target;

			//if not a link, click through
			if (e.nodeName=="A") {
				return true;
			} else {
				core.slideshowClick(tel,sdir);				
				return false;	
			}

		});	
		
	    $("body").on("mousemove", ".items", function(event) {		
			
			if (!touch) {

				var tel = $(this);
				var cursor = $(".cursor");
				var e = event.toElement || event.relatedTarget || event.target;
				var mouseY = event.clientY;
				var mouseX = event.clientX;
				var telpos = tel.offset();							
				var top = mouseY - telpos.top;
				var left = mouseX - telpos.left;					
								
				if (tel.hasClass("slideshow")) {
														
					if (wh-82<top) {
						
						slidedown = true;										
										
						if ($(".slide-active").hasClass("slide-half")) {
							var tcap = (left > (ww / 2)) ? $(".slide-active.right .cap") : $(".slide-active.left .cap") ;
						} else {
							var tcap = $(".cap");
						}
						var tcapwrap = tcap.find(".wrap");
						
						tcap.addClass("showfulltxt");
						
						if (tcap.hasClass("caphidden") && slideup) {
							tcapwrap.velocity("stop").velocity({marginTop: 0}, 180);
							slideup = false;
						}
						
					} else {
											
						slideup = true;					
						
						if ($(".slide-active").hasClass("slide-half")) {
							var tcap = (left > (ww / 2)) ? $(".slide-active.right .cap") : $(".slide-active.left .cap") ;
						} else {
							var tcap = $(".cap");
						}
						var tcapwrap = tcap.find(".wrap");
						
						if (tcap.length) {
													
							tcap.removeClass("showfulltxt");
							
							if (tcap.hasClass("caphidden") && slidedown) {
								tcapwrap.velocity("stop").velocity({marginTop: 87}, 180);
								slidedown = false;
							}
						
						}					
						
					}
				
				}				
					
				if (e.nodeName==="A") {
					
					if (cursor.hasClass("visible")) {
						cursor.removeClass("visible");
					}
					
				} else {						
					
					if (!cursor.hasClass("visible")) {
						cursor.addClass("visible");
					}
					
					if (left > (ww / 2)) {
						if (!cursor.removeClass("prev"));												
						if (!cursor.hasClass("next")) {
							cursor.addClass("next");
						}						
					} else {
						if (!cursor.removeClass("next"));						
						if (!cursor.hasClass("prev")) {
							cursor.addClass("prev");
						}							
					}								
						
					cursor.css({
			            top: mouseY + 1,
			            left: mouseX + 1
			        });
		        
		        }
		        						
			}
			
		});
		
	    $("body").on("mouseleave", ".items", function(e) {	
		    	
			var tel = $(this);
			var cursor = $(".cursor");
					 	
			if (cursor.hasClass("visible")) {
				cursor.removeClass("visible");
			}
			
	 	});

		$(document).on("keydown", function(e) {
			if (e.which == 37 && !e.metaKey) {
				e.preventDefault();
				core.slideshowClick($(".items"),"prev");
			} else if (e.which == 39 && !e.metaKey){
				e.preventDefault()
				core.slideshowClick($(".items"),"next");
			}
		});
		
	
    },
	
	rowHover: function() {
	 	
	 	$(".row").mouseover( function(e) {
		 	
		 	if (!touch) {
		 	
				var trow = $(this);
				var tthumb = trow.find(".thumb");				
				var mouseY = e.clientY + 15;
				var mouseX = e.clientX + 15;
				
				if (!tthumb.is(":visible")) {
					tthumb.css({
			            top: mouseY,
			            left: mouseX
			        }).velocity("stop").velocity("fadeIn",{duration: 80, display: "block"});
				}				
								
			 	$(".row").on("mousemove", function(e) {
				 						 			 	
					var trow = $(this);
					var tthumb = trow.find(".thumb");				
					var mouseY = e.clientY + 15;
					var mouseX = e.clientX + 15;
															
					tthumb.css({
			            top: mouseY,
			            left: mouseX
			        });
				        	 	
			 	});					
					
			}
			
	 	});
	 	
	 	$(".row").mouseleave( function(e) {
		 	
			var trow = $(this);
			var tthumb = trow.find(".thumb");				 	
		 	
		 	if (tthumb.is(":visible")) {
		 		tthumb.velocity("stop").velocity("fadeOut",{duration: 80});
		 	}
			
	 	});	 	
 
	},
	
	
	slideshowClick: function(sshow,sdir) {
		
		var condition;
    var slide = $('.slide-active');	
    let slidelength = 0
		
		$("header").css({top: 0});
	    
	    if (sdir=="prev") {
		    if (slide.first().next().hasClass("skipper-right") && !slide.first().next().hasClass("slide-active")) {
			    slidelength = 1;
		    } else {
			    slidelength = slide.first().prev(".slide").length;
		    }
		    pdir = "previous";
	    } else {
		    slidelength = slide.last().next(".slide").length;			    
			pdir = "next";
	    }
	    
		if (($(".project").length || $(".journalsingle").length) && slidelength==0) {
			
			var pbtn = (sdir=="prev") ? $(".pbtn.prev") : $(".pbtn.next") ; 
			var href = pbtn.attr("href");//link url
			var currhref = window.location.pathname;//current url
			var currtitle = document.title;
					
			if (href!=currhref) {
				History.pushState(null, currtitle, href);		
			}				

			oktohidehead = false;

		} else {

			core.slideshowMove(sshow,sdir,ww);
			
			if (mobile && $(".menu").is(":visible")) {
				$(".menu").velocity("slideUp",180);
				if ($(".logo").hasClass("black")) {
					$(".logo").removeClass("black");			
				}								
			}				
			
		}		
		
	},

	slideshowInit: function(sshow) {
				
		if (!sshow) {sshow = $(".slideshow")}
		    
	    //define slides to skip
	    if (!sreset) {
		    
			var slides = sshow.find(".slide").not(".skipper-right, .skipper-left");
  
			//define slides on the right			
			var cangoright = false;
			
			slides.each( function(index) {
				var tslide = $(this);
				if (cangoright) {
					if (tslide.hasClass("slide-half") && !tslide.hasClass("slide-right")) {
						tslide.addClass("slide-right");	
					}
					cangoright = false;				
				} else {
					//skip past slide on the left
					if (tslide.hasClass("slide-half")) {
						tslide.addClass("left")
						cangoright = true;
					}
				}
			});				

		}
				
	    //define active slides					    
	    var firstslide;
	    if (sreset) {
		    var slides = sshow.find(".slide-active");
		    if (touch) {
			    firstslide = slides.first();
		    } else {
			    if (slides.length == 1 && slides.hasClass("slide-half")) {
				    if (slides.hasClass("skipper-right")) {
						firstslide = slides.add(slides.prevAll(".skipper-left").last());
				    } else if (slides.hasClass("slide-right")) {
						firstslide = slides.add(slides.prev());
				    } else {
						firstslide = slides.add(slides.next());
				    }
			    } else {
					firstslide = slides;				    
			    }
		    }
		} else {
		    var slides = sshow.find(".slide");			
		    if (pdir=="previous") {
			    if (!touch && (slides.last().hasClass("slide-right") || slides.last().hasClass("skipper"))) {
					firstslide = slides.last().add(slides.last().prev());
			    } else {
					firstslide = slides.last();
			    }		    
		    } else {
			    if (!touch && (slides.first().next().hasClass("slide-right") || slides.first().hasClass("skipper"))) {
				    firstslide = slides.first().add(slides.first().next());
			    } else {
				    firstslide = slides.first();
			    }
		    }			
		}
		
	    firstslide.addClass("slide-active").show();		
	    if (touch) {
		    sshow.find(".slide").css({left: 0});
		    if (firstslide.hasClass("scrollonmob")) {
			    disabletap = true;
			    $("header").addClass("headerbg");
		    } else {
			    disabletap = false;
			    $("header").removeClass("headerbg");			    
		    }
		} else {
			firstslide.first().css({left: 0});
			if (firstslide.last().hasClass("slide-right") || firstslide.last().hasClass("skipper-right")) {
				firstslide.last().css({left: ww/2});			
			}
		}
	    sshow.find(".slide").not(firstslide).hide().removeClass("slide-active");	    
	    
	},
		
    slideshowMove: function(sshow,sdir,sw) {
				
		var slides = $('.slide');
		var slide = $('.slide-active');
			var skip = false;
			
			document.body.classList.remove('show-dots')
			setTimeout(()=>{document.body.classList.add('show-dots')}, 4000)
				
		if (sdir == 'next') {
			
			// #1 first check if there are any slides to skip
			if (!touch) {
			
				slide.each( function() {
					
					var tslide = $(this);
					var skipcount = tslide.data("skip");
					
					if (skipcount > 0) {
						
						var tendslide = tslide.nextAll(".skipper-right.slide-active").first();
											
						if (tendslide.next().hasClass("skipper-right")) {
							if (!tslide.hasClass("skipper")) {tslide.addClass("skipper")}
							slide = $('.slide-active').not(tslide);
							skip = true;
							scounter++;
						} else {
							tslide.removeClass("skipper");
							skip = false;
							scounter = 0;
						}
						
					}
				
				});			
			
			}
			
			// #2 move, hide and reposition the active slides in-view			
			slide.each( function() {

				var tslide = $(this);				
        var leftstartpos;		

				if (!touch && (tslide.hasClass("slide-right") || tslide.hasClass("skipper-right"))) {
					leftstartpos = -(ww / 2);
				} else {
					leftstartpos = -ww;
				}	

				tslide.stop().animate({
					left: leftstartpos
				}, sspeed, seasing, function() {
					$(this).hide(0);
				});

			});

			// #3 check if any of the slides in-view have slide-right class
			if (!touch && skip==false && slide.hasClass("slide-right")) {
				//if there is one, slide is one next to slide-right
				slide = $(".slide-right.slide-active").next(".slide");
			} else {
				//otherwise, slide is simply next to one that was in-view				
				slide = slide.last().next(".slide");
			}
			
			// #4
			if (!slide.length) {
				slide = slides.first(".slide");	
			}
									
			// #5 next slide is defined, now check if one from the right has slide-right class
			if (!touch && skip==false && (slide.next(".slide").hasClass("slide-right") || slide.next(".slide").hasClass("skipper-right"))) {
				//if there is one, add it to slide so we now have a pair
				slide = slide.add(slide.next(".slide"));
			}					
				
			// #6
			slide.each( function() {
				
				var tslide = $(this);
				var leftstartpos, leftendpos;
						
				if (!touch && (tslide.hasClass("slide-right") || tslide.hasClass("skipper-right"))) {
					leftstartpos = (ww + ww / 2);
					leftendpos = ww / 2;	
				} else {
					leftstartpos = ww;
					leftendpos = 0;						
				}	
							
				tslide.css({
					left: leftstartpos
				}).show(0).stop(0).animate({left: leftendpos}, sspeed, seasing);
									
			});
			
		} else {
			
			// #1 first check if there are any slides to skip
			if (!touch) {
			
				slide.each( function() {
					
					var tslide = $(this);
					var skipcount = tslide.data("skip");
					
					if (skipcount > 0) {
						
						var tendslide = tslide.nextAll(".skipper-right.slide-active").first();
						
						if (tendslide.prev().hasClass("skipper-right")) {
							if (!tslide.hasClass("skipper")) {tslide.addClass("skipper")}
							slide = $('.slide-active').not(tslide);
							skip = true;
							scounter++;
						} else {
							tslide.removeClass("skipper");
							skip = false;
							scounter = 0;
						}
						
					}
		
				});			
			
			}
			
			// #2 move, hide and reposition the active slides in-view			
			slide.each(function () {
				
				
				var tslide = $(this);				
        var leftstartpos;		

				if (!touch && (tslide.hasClass("slide-right") || tslide.hasClass("skipper-right"))) {
					leftstartpos = ww + ww / 2;
				} else {
					leftstartpos = ww;
				}
				
				tslide.stop().animate({
					left: leftstartpos
				}, sspeed, seasing, function() {
					$(this).hide(0);
				});
												
			});			
			
			// #3
			if (!touch && skip==false && slide.hasClass("slide-right")) {
				slide = slide.first().prev(".slide");
			} else {
				slide = slide.first().prev(".slide");
			}					
			
			// #4
			if (!slide.length) {
				slide = slides.last(".slide");
			}
			
			// #5 next slide is defined, now check if one from the right has slide-right class
			if (!touch) {			
				if (skip==false && slide.hasClass("slide-right")) {
					//if there is one, add it to slide so we now have a pair
					slide = slide.add(slide.prev(".slide"));
				} else if (skip==false && slide.hasClass("skipper-right")) {
					slide = slide.add(slide.prevAll(".skipper-left").first());
				}
			}
			
			// #6
			slide.each( function() {
				
				var tslide = $(this);
				var leftstartpos, leftendpos;					
				
				if (!touch && (tslide.hasClass("slide-right") || tslide.hasClass("skipper-right"))) {
					leftstartpos = ww / 2;
					leftendpos = ww / 2;	
				} else {
					leftstartpos = ww;
					leftendpos = 0;						
				}
				
				tslide.css({
					left: -leftstartpos
				}).show(0).stop(0).animate({left: leftendpos}, sspeed, seasing);	
								
			});

		}	
		
		// #7 check if journal slide
		if (slide.hasClass("item-journal")) {
			$("body").addClass("b_journal");	
			if (touch) {disabletap = true;}			
		} else {
			$("body").removeClass("b_journal");
			$("header").removeClass("headerbg");
			if (touch) {disabletap = false;}		
		}


		// #9 check if text slide
		if (slide.first().hasClass("scrollonmob") && !(slide.first().hasClass("slide-right") || slide.first().hasClass("skipper-right"))) {
			$(".btn.prev").addClass("btn-narrow");
			if (touch) {
				disabletap = true;
				$("header").addClass("headerbg");
			}
		} else if (slide.last().hasClass("scrollonmob") && (slide.last().hasClass("slide-right") || slide.last().hasClass("skipper-right"))) {
			$(".btn.next").addClass("btn-narrow");
			if (touch) {
				disabletap = true;
				$("header").addClass("headerbg");
			}
		} else {
			$(".btn").removeClass("btn-narrow");
			if (touch) {
				disabletap = false;
				$("header").removeClass("headerbg");
			}
		}
		if (slide.hasClass("textleft")){
			$(".btn.prev").addClass("btn-narrow");
			$(".btn.next").removeClass("btn-narrow");
		} else if (slide.hasClass("textright")){
			$(".btn.next").addClass("btn-narrow");
			$(".btn.prev").removeClass("btn-narrow");
		}
		
		// #10
		slide.addClass('slide-active');
		if (touch) {
			slides.not(slide).removeClass('slide-active');			
		} else {
			slides.not(slide).not(".skipper").removeClass('slide-active');			
		}
				
	}, 
    
	getPage: function(href) {

		if (href[0] != "/") {
			href = "/"+href;
		}
		if (prevhref[0] != "/") {
			prevhref = "/"+prevhref;
		}
		
		var l =  href.split("/");
		var pl =  prevhref.split("/");
		
		$("header").removeClass("hidden").find(".wrap").removeAttr("style");
		core.unbindHeaderHover();
		
		if (mobile && $(".menu").is(":visible")) {
			$(".menu").velocity("slideUp",180);
			if ($(".logo").hasClass("black")) {
				$(".logo").removeClass("black");			
			}								
		}
				
		switch(l[1]) {
			
			case "projects":
								
				//locate the link clicked anywhere
				var thislink = $("a[href='" + href + "']");	
				
				if ($("body").hasClass("b_info")) {
					$("body").removeClass("b_info");				
				}
					
				if (thislink.hasClass("getsubpage")) {
					var url = "/inc/project-content.php";
					core.loadAjaxSub(href,prevhref,url);
				} else {
					core.loadAjax(href,prevhref);
				}
				
			break;

			case "journal":

				//locate the link clicked anywhere
				var thislink = $("a[href='" + href + "']");	
				
				if (l[2]) {
					$("body").addClass("b_journal");	
				}
				
				if ($("body").hasClass("b_info")) {
					$("body").removeClass("b_info");				
				}
				
				if (thislink.hasClass("getsubpage")) {
					var url = "/inc/journalsingle-content.php";
					core.loadAjaxSub(href,prevhref,url);
				} else {
					core.loadAjax(href,prevhref);
				}
				
			break;			
			
			default:
								
				if (!$("body").hasClass("b_info")) {
					$("body").addClass("b_info");				
				}								
								
				core.loadAjax(href,prevhref);
				
			break;
			
		}

		prevhref = document.location.pathname;

	},
    
    loadAjax: function(href,prevhref) {
	    	    
		//locate the link clicked in navi
		var thislink = $("nav a[href='" + href + "']");
		//assume this is top navigation
		var navlevel = 1;
		//find lowest level (highest number)
		var linksfound = thislink.length;
		thislink.each(function(){
			var thislevel = thislink.closest("nav").data("level");
			if (thislevel > navlevel) navlevel = thislevel;
		});
		var thislink = $("nav[data-level='" + navlevel + "'] a[href='" + href + "']");
		
		//show/hide subnavi
		if (navlevel == 1){
			parenthref = href.substring(1);
			var nav2toshow = $("nav[data-parent='"+parenthref+"']");	
		} else {
			var nav2toshow = thislink.closest("nav");
		}
		$("nav[data-level='2']").not(nav2toshow).hide();
		nav2toshow.show();	
		
		//mark relevant navi items as selected
		$("nav a.selected").removeClass("selected");
		thislink.addClass("selected");
		var parenturl = thislink.closest("nav").data("parent");
		if (parenturl){
			thisparent = (parenturl[0] != "/") ? "/"+ parenturl : parenturl;
			$("nav[data-level='" + 1*(navlevel+1) + "'] a[href='" + thisparent + "']").addClass("selected");
			$("nav[data-level!='" + navlevel + "'] a[href='" + thisparent + "']").addClass("selected");
		} else {
			$("nav[data-level='" + 1*(navlevel+1) + "'] a[href='" + href + "']").addClass("selected");
		}
		
		core.scrollToTop();
		
		$('.include').velocity({
			opacity: 0
		}, {
			duration: 230,
			complete: function() {		
				$.ajax({
				    url: "/php/getpage.php",
					data: "ajax=1&href="+href+"&prevhref="+prevhref,
					success: function(resultdata) {

						if (resultdata.result == 1) {
							
							$('.include').html(resultdata.markup).velocity({
								opacity: 1
							}, {
								begin: function() {
									
									$(".btn").hide();
									
									sreset = false;
									
									//add body class
									if ($(".scrollable").length) {
										$("body").addClass("b_scrollable");
									} else {
										$("body").removeClass("b_scrollable");
									}									
									
									if ($(".journalsingle").length) {
										$("body").addClass("b_journal");
									} else {
										$("body").removeClass("b_journal");
									}		
									
									if ($(".slideshow").length) {
										core.slideshowInit();
									}
																		
									document.stitle = resultdata.pagetitle;
									
									core.siteResize();
									core.rowHover();
									
									oktopagemove = true;
									oktohidehead = true;									
																				
								},
								duration: 230
							});
		
						}
						
					},
				   	error: function(resultdata) {
				   		$("body").removeClass().addClass("b_error");
					   	$(".include").velocity({
						   	opacity: 0
						   }, {
						   	duration: 230,
						   	complete: function() {	
							   	$('.include').html("<div class='txtwrap'><h1>404</h1><p>The page you requested could not be found.</p></div>	").stop().velocity({
								   	opacity: 1
								}, 230);
							}
						});
					}
				});
			}
		});				   
	    
	},
	
	loadAjaxSub: function(href,prevhref,url) {
				
		var linkprev = $(".pbtn.prev");
		var linknext = $(".pbtn.next");
		var titems = $(".items-active");
								
		//ajax call
		$.ajax({
			data: "ajaxsub=1&href="+href+"&prevhref="+prevhref,
			url: url,
			success: function(resultdata) {
				
				//alert(resultdata);	
				
				if (resultdata.result == 1){
					
					$(".btn").hide();					
					
					//add content into inactive items container
					$('.items').not(titems).html(resultdata.markup);
					
					sreset = false;
					core.siteResize();
	

					if ($(".project").length) {
						core.slideshowInit($('.items').not(titems))
					}
					
					//add body class
					if ($(".scrollable").length) {
						$("body").addClass("b_scrollable");
					} else {
						$("body").removeClass("b_scrollable");
					}						

					document.title = sitetitle+": "+resultdata.pagetitle;
					linkprev.attr("href",resultdata.prevurl);
					linknext.attr("href",resultdata.nexturl);					
										
					pageMove(titems);
					
					oktohidehead = true;									

				}
				
			},
		   	error: function(resultdata) {
			   	
		   		$("body").removeClass().addClass("b_error");
		   		
				$('.items').not(titems).html("<div class='txtwrap'><h1>404</h1><p>The page you requested could not be found.</p></div>");		   		
		   		
		   		pageMove(titems);
		   		
			}
		});
		
		function pageMove(items) {
			
			var x = (pdir=="previous") ? ww : -ww ;
			
			//animate the two item containers
			items.velocity({
				left: x
			}, sspeed, function() {
				$(this).hide().empty();		
			});
			
			items = $(".items").not(items);
	
			items.css({
				left: -(x)
			}).show().velocity({
				left: 0
			}, sspeed, function() {
				oktopagemove = true;				
			});

			$(".items").not(items).removeClass("items-active");
			items.addClass("items-active");
			if (items.find(".item").hasClass("textleft")){
				$(".btn.prev").addClass("btn-narrow");
				$(".btn.next").removeClass("btn-narrow");
			} else if (items.find(".item").hasClass("textright")){
				$(".btn.next").addClass("btn-narrow");
				$(".btn.prev").removeClass("btn-narrow");
			}
			
		}		  
	    	
	},
    
    /* !RESIZE ---------------------------------------- */
    
    siteResize: function() {

		ww = $(window).width();
		wh = $(window).height();
		
		mobile = (ww<=414) ? true : false ;
		tablet = (ww>414&&ww<=768) ? true : false ;
		touch = (ww<=768) ? true : false ;		
				
		if (mobile) {
			
			offset = 30;
			sspeed = 340;											
			
			var projectrowtitlew = ww - offset - 72;			
			var inforowtitlew = ww - offset;	
			var captxtw = ww - 98 ;					
			
		} else if (tablet) {			

			offset = 60;
			sspeed = 440;				
			
			var projectrowtitlew = (ww - offset) * 0.477 - 72;						
			var inforowtitlew = ww - offset - 144;
			var captxtw = ww - 128 ;			
			
		} else {
			
			$(".menu").show();
			if ($(".logo").hasClass("black")) {
				$(".logo").removeClass("black");			
			}
			
			offset = 60;
			sspeed = 540;														
			
			var projectrowtitlew = (ww - offset) * 0.236 - 72;			
			var inforowtitlew = (ww - offset) * 0.49 - 134;
			var captxtw = ww / 2 - 128 ;
			
		}
		
		//reset header
		if ($(".slide-active").hasClass("slide-full")) {
			if (ww>1024) {
				$("header").addClass("hidden");
				core.bindHeaderHover();				
			} else {
				$("header").removeClass("hidden").find(".wrap").removeAttr("style");
				core.unbindHeaderHover();					
			}
		}
		
		$(".slide-half .captxt").css({maxWidth: captxtw});
		
		var txtwraph = (mobile || tablet) ? "auto" : wh ;
		$(".adjustheight").css({height: txtwraph});
				
		var sliderightlp = (touch) ? 0 : ww / 2 ;
		$(".slide-right, .skipper-right").css({
			left: sliderightlp
		});
				
		var sbtnh = (mobile) ? wh - 54 : wh - 76 ;
		$(".btn").height(sbtnh);
		
		$(".itemswrap").css({
			width: ww,
			height: wh
		});

		//projects info row titles		
		$(".projects .row .title").width(projectrowtitlew);		
		
		//resize info row titles
		$(".info .row .title").width(inforowtitlew);

		//resize imgs
		$(".scale").each(function() {
		
			var img = $(this);
			var slide = img.closest(".item");
			var imgh = img.height();
			var imgw = img.width();
			var imgr = img.data("ratio");
			
			var ow, oh, nelh, nelw, lp, tp;		
			
			if (slide.hasClass("slide-half")) {
				ow = (touch) ? ww : ww / 2 ;
			} else if (slide.hasClass("item-journal")) {
				ow = ww - offset;
				oh = (mobile) ? wh - 182 : wh - 224 ;
			} else {
				ow = ww;
				oh = wh;			
			}

			if (img.hasClass("half-full")) {
				oh = wh;
			} else if (img.hasClass("half-centered")) {
				if (ww<768) {
					oh = wh - 171;
				} else {
					oh = wh - 242;
				}
				ow = (touch) ? ww - 84 : (ww / 2) - 252;	
			}
						
			if (imgr<=ow/oh) {
				nelh = oh;
				nelw = imgr * nelh;
				lp = (ow - nelw) / 2;
				tp = 0;
				if (nelw < ow && (img.hasClass("full") || img.hasClass("half-full"))) {
					nelw = ow;
					nelh = nelw / imgr;
					lp = 0;
					tp = (oh - nelh) / 2;
				}
			} else {
				nelw = ow;
				nelh = nelw / imgr;
				lp = 0;
				tp = (oh - nelh) / 2;
				if (nelh < oh && (img.hasClass("full") || img.hasClass("half-full"))) {
					nelh = oh;
					nelw = imgr * nelh;
					lp = (ow - nelw) / 2;
					tp = 0;
				}	
			}
			
			if (img.hasClass("full-width") || img.hasClass("full-height")) {
				lp = 0;
				tp = 0;
			} else if (img.hasClass("half-centered")) {
				lp = (touch) ? lp + 42 : lp + 126;
				tp = (ww<768) ? tp + 85 : tp + 110;
			}
			
			if (slide.hasClass("item-journal")) {
				tp = offset + 58;
				lp = (ow - nelw) / 2 + offset / 2 ;
			}			
						
			img.css({
				width: nelw,
				height: nelh,
				marginLeft: lp,
				marginTop: tp
			});

	
			
		});


    },
    
    showMoreText: function() {
		var showmore = $(".showmore");
		var txtwrapinner = $(".adjustheight:visible .txtwrapinner");	
		if (showmore.length) {			
			if (touch) {
				showmore.hide();
			} else {
				var txtwrapinnerh = txtwrapinner.outerHeight(true);
				if (txtwrapinnerh>wh) {
					showmore.velocity("stop").velocity("fadeIn",80);
				} else {
					showmore.velocity("stop").velocity("fadeOut",80);
				}
			}
		}    
    },
    
	scrollInsideTxt: function() {
	    $(".adjustheight").on("scroll", function(e) {
		    
		    var el = $(this);
			var y = el.scrollTop();
			var scrollh = el.prop("scrollHeight");
		    var showmore = $(".showmore");
		    
		    if (scrollh==y+wh) {
			    showmore.velocity("stop").velocity("fadeOut",80);
		    } else {
			    if (!showmore.is(":visible")) {
				    showmore.velocity("stop").velocity("fadeIn",80);			    				    
			    }
		    }
		    		    
			if ($(".b_journal").length && !$("header").hasClass("headerbg")) {
				var tel = $(this);
				$("header").addClass("headerbg");
				
			}
		});		
	},
    
  
    scrollToTop: function() {
	    
		$("html:not(:animated),body:not(:animated)").velocity("scroll", {
			duration: 340,
			easing: 'easeOutCubic'
		});
		
	},
    
}

$( document ).ready( core.init );
